<template>
  <div id="queueTasks">
    <div class="search-section">
      <el-drawer :visible.sync="bindFormVisible" title="绑定">
        <div>
          你确定要绑定这
          <strong>{{ selectedTaskIds.length }}</strong> 个案件吗？
        </div>
        <el-form>
          <el-form-item label="选择绑定人">
            <el-select
              v-model="bindAgentId"

              placeholder="请选择..."
            >
              <el-option
                v-for="agentInfo in manageQueueAgents"
                :key="agentInfo.id"
                :label="agentInfo.name"
                :value="agentInfo.id + ',' + agentInfo.workQueueId"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button  @click="bindFormVisible = false"
              >取 消</el-button
            >
            <el-button  type="primary" @click="handleBind"
              >确 定</el-button
            >
          </el-form-item>
        </el-form>
      </el-drawer>
      <el-card class="box-card" shadow="never">
        <el-form
          :inline="true"
          :model="searchParams"

          class="demo-form-inline"
        >
          <el-form-item label="业务类型">
            <el-select
              v-model.trim="searchParams.businessType"
              placeholder="业务类型"
            >
              <el-option
                v-for="item in businessTypeList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="产品">
            <el-select v-model.trim="searchParams.product" placeholder="产品">
              <el-option
                v-for="item in productList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="合同编号">
            <el-input
              v-model.trim="searchParams.contractNumber"
              placeholder="合同编号"
            />
          </el-form-item>
          <el-form-item label="客户姓名">
            <el-input
              v-model.trim="searchParams.borrowerName"
              placeholder="客户姓名"
            />
          </el-form-item>
          <el-form-item label="逾期日期">
            <el-date-picker
              v-model="yuQi"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="yuQiChange"
            />
          </el-form-item>
          <el-form-item label="案件状态">
            <el-select v-model="searchParams.status" placeholder="案件状态">
              <el-option
                v-for="item in statusList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="处理人">
            <el-autocomplete
              v-model="bindingAgentId"
              :fetch-suggestions="querySearch"
              placeholder="请输入处理人"
              @select="handleSelect"
            ></el-autocomplete>
          </el-form-item>
          <el-form-item label="分案时间">
            <el-date-picker
              v-model="fenAn"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              @change="fenAnChange"
            />
          </el-form-item>
          <el-form-item label="服务费筛选">
            <el-select v-model.trim="searchParams.serviceFeeFilter" placeholder="服务费筛选">
              <el-option label="全部" value="" />
              <el-option label="仅服务费" value="2" />
              <el-option label="借款+服务费" value="3" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search">查询</el-button>
            <el-button

              type="primary"
              @click="bindFormVisible = true"
              >绑定</el-button
            >
            <el-button type="" @click="clear">清空</el-button>
            <el-button @click="download">导出</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
    <div class="table-section">
      <el-table
        :data="manageQueueTasksList"
        :header-row-style="headerRowStyle"
        max-height="550px"
        border
        highlight-current-row
        style="width: 100%"
        @selection-change="handleQueueTaskListChange"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column prop="businessType" label="业务类型">
          <template slot-scope="scope">
            {{
              scope.row.businessType === "1"
                ? "爱分担"
                : scope.row.businessType === "2"
                ? "分担宝"
                : scope.row.businessType === "3"
                ? "助贷通道"
                : scope.row.businessType === "4"
                ? "好易付"
                : scope.row.businessType === "5"
                ? "实物租赁"
                : scope.row.businessType === "6"
                ? "乐享付"
                : "-"
            }}
          </template>
        </el-table-column>
        <el-table-column prop="productTypeName" label="产品" />
        <el-table-column prop="contractNumber" label="合同编号" width="200" />
        <el-table-column prop="borrowerName" label="客户姓名" />
        <el-table-column prop="overdueDate" label="逾期日期" width="150" />
        <el-table-column prop="overdueDays" label="逾期天数" />
        <el-table-column prop="amount" label="逾期金额" />
        <el-table-column prop="taskStatus" label="案件状态" />
        <el-table-column prop="lastCallResult" label="最新结果" />
        <el-table-column prop="lastCallTime" label="最近跟进时间" width="150" />
        <el-table-column prop="lastCallAgent" label="处理人" />
        <el-table-column
          prop="lastBindAgentTime"
          label="分案时间"
          width="150"
        />
      </el-table>
    </div>
    <div class="pagination-section">
      <el-pagination
        :page-size="pageSize"
        :total="manageQueueTasksListTotalCount"
        layout="total, prev, pager, next"
        @current-change="changePage"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import * as manageApi from "../../api/manage.js";
import {
  getWorkQueueList,
  getDictionaryList,
  getUser,
  exportWorkQueueManageList,
} from "@/api/manage";
// import api from '../../api.js'

export default {
  name: "queueTasks",
  data() {
    return {
      headerRowStyle: {
        "background-color": "#6584b4",
      },
      searchParams: {},
      fenAn: [],
      yuQi: [],
      bindingAgentId: "",
      pageSize: 15,
      page: 1,
      selectedTaskIds: [],
      bindAgentId: null,
      bindFormVisible: false,
      unbindFormVisible: false,
      workQueueNameList: [],
      businessTypeList: [],
      productList: [],
      statusList: [],
    };
  },
  computed: {
    ...mapGetters([
      "currentUser",
      "manageQueueInfo",
      "manageQueueTasksList",
      "manageQueueTasksListTotalCount",
      "manageQueueAgents",
    ]),
    queueId() {
      return this.$route.params.queueId;
    },
  },
  watch: {
    $route() {},
  },
  async created() {
    this.loadTasks();
    const getWorkQueueListRes = await getWorkQueueList();
    getWorkQueueListRes.data.map((item) => {
      this.workQueueNameList.push({
        label: item.name,
        value: item.id,
      });
    });
    const fdBusinessTypeRes = await getDictionaryList("fd_business_type");
    fdBusinessTypeRes.data.map((item) => {
      this.businessTypeList.push({
        label: item.dictLabel,
        value: item.dictValue,
      });
    });
    const profuctRes = await getDictionaryList("product_type");
    profuctRes.data.map((item) => {
      this.productList.push({
        label: item.dictLabel,
        value: item.dictValue,
      });
    });
    const statusRes = await getDictionaryList("task_status");
    statusRes.data.map((item) => {
      this.statusList.push({
        label: item.dictLabel,
        value: item.dictValue,
      });
    });
  },
  methods: {
    ...mapActions(["fetchQueueInfo", "fetchQueueTasks", "fetchQueueAgents"]),
    async querySearch(queryString, cb) {
      const results = [];
      if (queryString) {
        const getUserRes = await getUser(queryString);
        if (getUserRes.data.length > 0) {
          getUserRes.data.map((item) => {
            results.push({
              value: item.name,
              id: item.id,
            });
          });
        }
      }
      cb(results);
    },
    handleSelect(item) {
      this.searchParams.bindingAgentId = item.id;
    },
    /**
     * 导出
     */
    async download() {
      this.searchParams.userId = this.currentUser.id;
      const exportWorkQueueManageListRes = await exportWorkQueueManageList(
        this.queueId,
        this.searchParams
      );
      this.$message.success(exportWorkQueueManageListRes.data);
    },
    yuQiChange(val) {
      if (val && val.length) {
        this.searchParams.overdueStartDay = val[0];
        this.searchParams.overdueEndDay = val[1];
      } else {
        this.searchParams.overdueStartDay = "";
        this.searchParams.overdueEndDay = "";
      }
    },
    fenAnChange(val) {
      if (val && val.length) {
        this.searchParams.lastBindAgentTimeStart = val[0];
        this.searchParams.lastBindAgentTimeEnd = val[1];
      } else {
        this.searchParams.lastBindAgentTimeStart = "";
        this.searchParams.lastBindAgentTimeEnd = "";
      }
    },
    loadTasks() {
      this.fetchQueueInfo({ queueId: this.queueId });
      this.searchParams.userId = this.currentUser.id;
      this.fetchQueueTasks({
        queueId: this.queueId,
        searchParams: this.searchParams,
        page: this.page,
        size: this.pageSize,
      });
      this.fetchQueueAgents({ queueId: this.queueId });
    },
    changePage(currentPage) {
      this.page = currentPage;
      this.loadTasks();
    },
    search() {
      this.page = 1;
      this.loadTasks();
    },
    clear() {
      this.searchParams = {};
      this.fenAn = [];
      this.yuQi = [];
      this.bindingAgentId = "";
      this.search();
    },
    handleQueueTaskListChange(val) {
      this.selectedTaskIds = val.map((item) => {
        return item.id;
      });
    },
    handleBind() {
      if (this.selectedTaskIds.length < 1) {
        this.bindFormVisible = false;
      } else {
        const bindAgentIdList = this.bindAgentId.split(",");
        manageApi
          .bindQueueAgent(
            this.selectedTaskIds.join(","),
            bindAgentIdList[0],
            this.currentUser.name,
            this.currentUser.id,
            bindAgentIdList[1]
          )
          .then((res) => {
            this.bindFormVisible = false;
            if (res.data === "success") {
              this.$notify({
                title: "绑定成功！",
                type: "success",
                duration: 5000,
              });
              this.loadTasks();
            } else {
              this.$notify.error({
                title: "解绑出错！",
                message: res.data,
                type: "error",
                duration: 0,
              });
            }
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped="">
.button-area {
  position: absolute;
  right: 20px;
  top: 120px;
}
</style>
